import axios from "axios";

const headers = {
  post: {
    "Content-Type": "application/json",
  },
};

const defaultConfig = {
  baseURL: "/api",
  timeout: 10000,
  headers,
};

const client = axios.create(defaultConfig);

client.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  (response) => {
    // status 200
    return response;
  },
  async (error) => {
    // const originalRequest = error.config;
    const {
      response: {
        status,
        data: { code },
      },
      config: originalRequest,
    } = error;
    // accessToken이 만료된 경우
    if (
      status === 401 &&
      (code === "INVALID_ACCESS_TOKEN" || code === "ACCESS_TOKEN_NOT_FOUND")
    ) {
      axios
        .post("/api/auth/refresh-token")
        .then(({ status: refreshTokenStatus, data: { accessToken } }) => {
          if (refreshTokenStatus === 200) {
            // refreshToken 이용해서 accessToken 새로 발급
            // cookie에 있는 refreshToken도 새로 set-cookie가 된다.
            // const accessToken = response.data.accessToken;

            // 새로 발급받은 accessToken을 다음에도 사용할 수 있도록 client instance header에 set
            client.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${accessToken}`;

            // 이전에 accessToken 만료로 실패했던 요청 다시 실행
            originalRequest.headers["Authorization"] = "Bearer " + accessToken;
            return client(originalRequest);
          }
        })
        .catch((error) => {});
    }

    return Promise.reject(error);
  }
);

export default client;
